// src/components/atoms/Profile/Edit/SaveChangesButton.js

import React from "react";
import { Button } from "@mui/material";
import { useTheme } from "styled-components";

const SaveChangesButton = ({ onClick }) => {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      sx={{
        backgroundColor: theme.colors.blue,
        color: theme.colors.white,
        borderRadius: "50px",
        padding: "10px 30px",
        textTransform: "none",
        boxShadow: 'none',
        "&:hover": {
          backgroundColor: theme.colors.green,
          boxShadow: 'none',
        },
      }}
    >
      Save Changes
    </Button>
  );
};

export default SaveChangesButton;
